/* eslint-disable camelcase */

import ReactComponentRegistry from 'react_component_registry';
import type {
  AccountantLeadFormDetails,
  PartnerQuestionType,
  AccountantLeadPayload,
} from './types';

const getSubmitPayload = (
  values: AccountantLeadFormDetails,
  surveyAnswers: PartnerQuestionType
) => {
  const accountantLead = {
    first_name: values.accountant_lead.first_name,
    last_name: values.accountant_lead.last_name,
    email: values.accountant_lead.email,
    accounting_firm_name: values.accountant_lead.accounting_firm_name,
    number_companies_bucket: values.accountant_lead.number_companies_bucket,
    number_payroll_services_clients_bucket:
      values.accountant_lead.number_payroll_services_clients_bucket,
    website: values.accountant_lead.website,
    phone: values.accountant_lead.phone,
    signup_goals: surveyAnswers.signupGoals?.join(','),
    run_payroll_for_clients: surveyAnswers.runPayrollForClients,
    offer_advisory_services: surveyAnswers.offerAdvisoryServices,
    perk_goals: surveyAnswers.perkGoals?.join(','),
  } as AccountantLeadPayload;

  return {
    authenticity_token: ReactComponentRegistry.authenticityToken(),
    accountant_lead: accountantLead,
    accountant_from_react: true,
  };
};

export default getSubmitPayload;
